
<div>
    <h2 class="mat-subheading-2">Solicitud de firma</h2>
</div>
<div class="terms-and-conditions container mx-auto px-7 pb-3 block">
    <div class="w-full columns-1 w-4/5 mx-auto" *ngIf="!withouturl" >
        Favor de presionar el botón de "Firmar solicitud" para abrir el documento que requiere su firma
        <div class="w-full">
            <!-- <div class="link-button" (click)="openUrl()">{{url}}</div> -->
            <button mat-flat-button color="primary" (click)="openUrl()" class="mt-4 mb-4">Firmar solicitud</button>
        </div>
    </div>

    <div *ngIf="withouturl" class="error-component">
        <span>
            No fue posible obtener la url para la firma, intente más tarde
        </span>
    </div>
</div>
